import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const Header = () => {
    const { isAuthenticated, logout } = useAuth();
    const navigate = useNavigate();

    return (
        <header className="app-header">
            <div className="header-content">
                <a href={isAuthenticated ? "/dashboard" : "/templates"} className="header-brand">
                    <span className="brand-icon">📜</span>
                    <span className="brand-text">Генератор Договоров</span>
                </a>
                <nav className="header-nav">
                    <button type="button" onClick={() => navigate('/templates')} className="nav-button nav-button-secondary">Шаблоны</button>
                    <button type="button" onClick={() => navigate('/contacts')} className="nav-button nav-button-secondary">Контакты</button>

                    {isAuthenticated ? (
                        <>
                            <button type="button" onClick={() => navigate('/dashboard')} className="nav-button nav-button-secondary">👤 Личный кабинет</button>
                            <button type="button" onClick={logout} className="nav-button nav-button-secondary">Выход</button>
                        </>
                    ) : (
                        <>
                            <button type="button" onClick={() => navigate('/login')} className="nav-button nav-button-secondary">Войти</button>
                            <button type="button" onClick={() => navigate('/register')} className="nav-button nav-button-primary">Регистрация</button>
                        </>
                    )}
                </nav>
            </div>
        </header>
    );
};

export default Header;